import { useLocation } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import './style.css'


const TempleInnImages=[
"https://r2imghtlak.ibcdn.com/r2-mmt-htl-image/htl-imgs/201805211757525155-c500443b-c639-4e33-bd19-c67619065594.jpg",
"https://r1imghtlak.ibcdn.com/c4aa8785-cefe-4164-9e42-a9404b52f152.jpg",
"https://r2imghtlak.ibcdn.com/r2-mmt-htl-image/room-imgs/201805211757525155-1099626-0a5101fe-49fb-4b1e-9b53-d38c2e87893d.jpg",
"https://r1imghtlak.ibcdn.com/cc3e7fa25f3e11e89ec20a0cf73b24d6.jpg",
"https://r2imghtlak.ibcdn.com/r2-mmt-htl-image/htl-imgs/201805211757525155-6dbb715d-e2af-4430-9b0a-784a679d544d.jpg",

"https://r2imghtlak.ibcdn.com/r2-mmt-htl-image/space-imgs/201805211757525155-149315-bc5beb05-7ddd-46cc-9f17-a243763037c1.jpg",
"https://r1imghtlak.ibcdn.com/fd3124db-660c-4071-a326-dd3203f5cefc.jpg",

"https://pix8.agoda.net/hotelImages/4990856/0/c44d60550d96fa643efcb47663ffdc80.jpg?va=1&ce=3&s=1024x",
"https://pix8.agoda.net/hotelImages/4990856/0/0f81a7d37fcce02fcbf8e808f14732a6.jpg?va=1&ce=3&s=1024x",
"https://pix8.agoda.net/hotelImages/4990856/0/c484b549f9152ffc3748f521414c68e3.jpg?va=1&ce=3&s=1024x"
]

const DaanAmbalath = () => {


const pathname = window.location.pathname;
const daanPath = pathname.toLowerCase().startsWith("/daan")
  ? pathname
  : null;

console.log("Daan Path:", daanPath); // Log the Daan path for debugging

  return (
   <div className='daan-ambalath'>
      <Header gallery={daanPath} number={"+91 -963-383-3022"}  bgcolor={"rgb(81, 131, 116)"} booklink={'https://be.aiosell.com/book/b33dc0f174'}></Header>
      <section className='section-1'> <h1>DAAN AMBALATH </h1> <h3>Luxury Business Hotel</h3>  <p>Ambalath Maple Leaves, Behind Devaswom, Ponnuparambil Guruvayur, Kerala 680101, <span style={{padding:"10px"}}> <p style={{textDecoration:"underline"}}>Mob: 91 9633833022</p></span></p>
       <button onClick={()=>window.open('https://be.aiosell.com/book/b33dc0f174')} className='ambalath-btn'>Book Now</button> <div className="sec-1-images">
        <img src={TempleInnImages[0]} alt="" />
        <img src={TempleInnImages[1]} alt="" />
        <img src={TempleInnImages[2]} alt="" />
        </div> </section>
      <section className='section-2'> 
        <div className="sec-2-card">
           <h2>Experience Unmatched Luxury in Our Signature Rooms</h2>  <br />


           <p>Step into a world where elegance meets absolute comfort. Our signature rooms are thoughtfully
             designed to elevate your stay with refined interiors, plush furnishings, and serene views that inspire relaxation.
              Every corner reflects timeless sophistication — from the soft ambient lighting to the carefully curated décor. 
            Whether you’re visiting for business or leisure, our rooms provide a sanctuary where comfort and class coexist seamlessly.
            </p>  
        </div>  
         <img className='img-shade' src={TempleInnImages[3]} alt="" />
          </section>
   <section className='section-3'>
    <h1>24 Room & Suits</h1>  <button style={{width: '120px', margin:'auto'}} onClick={()=>window.open('https://be.aiosell.com/book/b33dc0f174')} className='ambalath-btn'>Book Now</button>
    <div className="sec-3-cards">
      <div className="sec-3-card-1">
        <img src={TempleInnImages[4]} alt="" />
        {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
          <dash></dash>
        <p>Standard AC Room</p>
      </div>
         <div className="sec-3-card-1">
        <img src={TempleInnImages[5]} alt="" />
            {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
      <dash></dash>
        <p>Deluxe AC Room</p>
      </div>   <div className="sec-3-card-1">
        <img src={TempleInnImages[6]} alt="" />
            {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
         <dash></dash>
        <p>Premium Family Room</p>
      </div>
    </div>
   </section>

       <section className='section-4'> 
          <div className="sec-4-card">
        <h1>Personalized Guest Services for Your Every Need</h1> <br />
         <p>Our guest services team is dedicated to curating an exceptional stay customized to your desires.
           From arranging transportation and dining reservations to fulfilling special requests, we are here to assist
           you with warmth and professionalism. Allow us to take care of the details while you relax and enjoy a seamless
            and luxurious experience.</p> 
          </div>

      <div className="sec-4-card-2">
       <img className='img-shade' src={TempleInnImages[7]} alt="" />
       <p className='img-p'>To ensure your stay is consistently pleasant, our service teams operate around the clock..</p>
      </div>
       </section>

<section className='section-5' >
  <div className="sec-5-card">
      <button onClick={()=>window.open('https://be.aiosell.com/book/b33dc0f174')} className='ambalath-btn'>Book Now</button>
  <h2 className='sec-5-bold'>Where Luxury Meets Function—Perfect for Work and Leisure</h2>
<img src={TempleInnImages[8]} alt="" />
<p className='img-p' >
   It’s a refined lifestyle crafted for those who appreciate the extraordinary.</p>
  </div>
 <img className='sec-5-img img-shade' src={TempleInnImages[9]} alt="" />
</section>

<div className="thekkady-map">
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.8768138990554!2d76.04181087586737!3d10.588803262624818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba795d1ed3614c5%3A0x562d1886ade90992!2sDaan%20Ambalath%20Maple!5e0!3m2!1sen!2sin!4v1770028585404!5m2!1sen!2sin"
 width="40%"
   height="450px"
    allowfullscreen=""
     loading="lazy" 
     referrerpolicy="no-referrer-when-downgrade"></iframe>
  <p>Ambalath Maple Leaves, Behind Devaswom, Ponnuparambil Guruvayur, Kerala 680101, <span style={{ textDecoration:"underline", padding:"0px"}}> Mob:91 9633833022</span></p>
</div>

 <Footer num={9633833022}/>
 

    </div>
  )
}

export default DaanAmbalath